module.exports = __webpack_public_path__ + "img/BGChatTT.cb4e5d02.png";